// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".formParam .el-form--label-top .el-form-item__label {\n  padding: 0;\n}\n.divClass {\n  background-color: #F5F7FA;\n  border: 1px solid #E4E7ED;\n  color: #C0C4CC;\n  cursor: not-allowed;\n  height: 32px;\n  width: 100%;\n  font-size: 14px;\n}", ""]);
// Exports
module.exports = exports;
